import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LocationsRoutingModule } from './locations-routing.module';
import { LocationsComponent } from './locations.component';
import { CreateLocationComponent } from './create-location/create-location.component';
import { EditLocationComponent } from './edit-location/edit-location.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule, FormFieldModule } from 'src/app/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';


@NgModule({
  declarations: [
    LocationsComponent,
    CreateLocationComponent,
    EditLocationComponent
  ],
  imports: [
    CommonModule,
    LocationsRoutingModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    FormFieldModule,
    ControlsModule,
    NgbModule,
    ReusableModule
  ]
})
export class LocationsModule { }
